import { useSidebarVisibilityStore } from '@shared/store/sidebarVisibilityStore';
import { FullPageLoader } from '@shared/components/LoadingSpinner';

/**
 * Gates a route behind the customer lifecycle stage (sidebar visibility matrix).
 * `section` is the key in the sidebar visibility API response, e.g. 'dashboard',
 * 'invoices', 'quotations'. While the section is hidden for the current stage,
 * the content area stays empty — the sidebar (e.g. Checkout) is the only navigation.
 */
export function LifecycleGuard({ section, children }) {
  const { lastFetched, error, isItemVisible } = useSidebarVisibilityStore();

  // Visibility not known yet (first fetch still in flight)
  if (!lastFetched && !error) {
    return <FullPageLoader />;
  }

  if (!isItemVisible(section)) {
    return null;
  }

  return children;
}
